import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { ConditionWatcher } from './condition-watcher';
export { ConditionWatcher };
import { conditionWatcherSchema } from '@schemas/business-objects/condition-watcher';
import { TenantFormGroup } from './tenant-form-group';
import { TokenFormGroup } from './token-form-group';

export class ConditionWatcherFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    boundaryEventId: SchemaFormControl;
    conditionExpression: SchemaFormControl;
    status: SchemaFormControl;
    createdAt: SchemaFormControl;
    updatedAt: SchemaFormControl;
    tokenId: SchemaFormControl;
    token: TokenFormGroup;
    tenantId: SchemaFormControl;
    tenant: TenantFormGroup;
  };

  declare value: Partial<ConditionWatcher>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(conditionWatcherSchema, ConditionWatcher, data, options);
  }

  get object(): ConditionWatcher {
    return new ConditionWatcher(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'token':
        return new TokenFormGroup();
      case 'tenant':
        return new TenantFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<ConditionWatcher[]> {
    return ConditionWatcher.find(filter);
  }

  static async findOne(filter?: any): Promise<ConditionWatcher | null> {
    return ConditionWatcher.findOne(filter);
  }

  static async findById(id: string, filter?: any): Promise<ConditionWatcher> {
    return ConditionWatcher.findById(id, filter);
  }

  static async create(
    data: Partial<ConditionWatcher>,
  ): Promise<ConditionWatcher> {
    return ConditionWatcher.create(data as any);
  }

  static async updateById(
    id: string,
    updates: Partial<ConditionWatcher>,
  ): Promise<ConditionWatcher> {
    return ConditionWatcher.updateById(id, updates as any);
  }

  static async deleteById(id: string): Promise<boolean> {
    return ConditionWatcher.deleteById(id);
  }
}

export class ConditionWatcherFormArray extends PersistedFormArray {
  declare controls: ConditionWatcherFormGroup[];

  readonly entityName = 'ConditionWatcher' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(conditionWatcherSchema, ConditionWatcher, options);
  }

  protected override createItemGroup() {
    return new ConditionWatcherFormGroup();
  }

  get array(): ConditionWatcher[] {
    return this.controls.map(
      (group: ConditionWatcherFormGroup) => group.object,
    );
  }
}

export class ConditionWatcherPersistedArray extends PersistedArray<ConditionWatcher> {
  readonly entityName = 'ConditionWatcher' as const;

  constructor(options?: PersistedArrayOptions) {
    super(ConditionWatcher, options);
  }
}
